import type { ChatResponseType } from '../../enums/index.js';
import type { Chat } from '../../types/index.js';
import { safeJsonDateRequired, transformDates } from './date.js';

export function transformChatQuery(data: Chat.Query<ChatResponseType, string>): Chat.Query {
  return {
    ...data,
    state: transformDates(data.state) as Chat.QueryState.Value<ChatResponseType>,
    citations: data.citations.map<Chat.Citation>((citation) => transformDates(citation) as Chat.Citation),
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}
